import {
  CreateSevenroomsAudienceData,
  SevenroomsAudience,
} from '@models/venue/integrations/SevenroomsAudience'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { INTEGRATIONS_SEVENROOMS_AUDIENCE_URL } from '@utils/urls'

const fetchSevenroomsAudiences = (params: TableParams) =>
  SBAPI.FetchPaginated<SevenroomsAudience[]>(
    INTEGRATIONS_SEVENROOMS_AUDIENCE_URL,
    params
  )

const fetchVenuesForSevenroomsAudience = (audienceId: number) =>
  SBAPI.Fetch<{ venues: { id: string; name: string }[] }>(
    `${INTEGRATIONS_SEVENROOMS_AUDIENCE_URL}/${audienceId}/venues`
  )

const createSevenroomsAudience = (audience: CreateSevenroomsAudienceData) =>
  SBAPI.Post(INTEGRATIONS_SEVENROOMS_AUDIENCE_URL, audience)

export {
  createSevenroomsAudience,
  fetchSevenroomsAudiences,
  fetchVenuesForSevenroomsAudience,
}
